import { createEvent } from "effector";
import { TChangePasswordStore } from "./types";

export const changePasswordInputType = createEvent<{
    key: keyof TChangePasswordStore,
    type: React.HTMLInputTypeAttribute
}>();

export const setInputValue = createEvent<{ key: keyof TChangePasswordStore, value: string }>();

export const setPasswordsStore = createEvent<TChangePasswordStore>();

export const resetErrors = createEvent<keyof TChangePasswordStore>();

export const confirmChangePassword = createEvent();

export const resetFeaturesData = createEvent();